// #region Dependencias
import styled from 'styled-components'
import { InputLabel, TextError } from 'components/Library'
import { colors } from 'components/Library/theme'
// #endregion

// #region Estilos
export const StyledInputContainer = styled.div`
  margin-bottom: 0.5rem;
  min-width: 120px;
  width: 100%;
`

const StyledInput = styled.input`
  background-color: transparent;
  border: 2px solid
    ${({ color = 'primary' }) =>
      color === 'primary'
        ? colors.primary
        : color === 'secondary'
        ? colors.secondary
        : color === 'tertiary'
        ? colors.tertiary
        : color === 'dark'
        ? colors.text
        : color};
  border-radius: 0.5rem;
  font-size: 1rem;
  padding: 1rem;
  width: 100%;
`
// #endregion

/**
 * Componente para renderizar un <input /> con su respectiva funcionalidad.
 *
 * @class
 * @example
 * <Input error="Campo invalido" helper="Ingresar nombre" label="Nombre" maxLength={40} name="nombre" value="valor" onChange={handleInputChange} />
 *
 * @param {Object} props - Propiedades del componente.
 * @param {string} [props.className=null] - Clase CSS para aplicar al campo.
 * @param {string} props.color - Color del elemento.
 * @param {string} props.error - Mensaje de error a mostrar debajo del campo.
 * @param {string} [props.helper=null] - Texto de ayuda del campo.
 * @param {string} props.label - Texto de la etiqueta del campo.
 * @param {number} [props.maxLength=null] - Longitud máxima del texto permitido en el campo.
 * @param {string} props.name - Nombre del campo, utilizado como valor del atributo 'htmlFor' de la etiqueta.
 * @param {string} [props.type="text"] - Tipo de campo.
 * @param {string} props.value - Valor actual del campo.
 * @param {React.ReactNode} props.children - Contenido que será renderizado dentro del componente.
 * @param {Function} props.onChange - Callback que se ejecuta al modificar el valor del campo.
 */
const Input = ({
  className,
  color,
  error,
  helper,
  label,
  maxLength,
  name,
  type = 'text',
  value,
  children,
  ...props
}) => {
  return (
    <StyledInputContainer>
      <InputLabel
        color={color}
        helper={helper}
        htmlFor={name}
        label={label}
        maxLength={maxLength}
        value={value}
      />
      <StyledInput
        color={color}
        maxLength={maxLength}
        name={name}
        type={type}
        value={value}
        {...props}
      >
        {children}
      </StyledInput>
      <TextError error={error} />
    </StyledInputContainer>
  )
}

export default Input
